import { render, staticRenderFns } from "./import-pt.vue?vue&type=template&id=5e63ebe4&"
import script from "./import-pt.vue?vue&type=script&lang=js&"
export * from "./import-pt.vue?vue&type=script&lang=js&"
import style0 from "./import-pt.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports